<template>
  <el-row
    type="flex"
    :justify="justify"
    :align="align"
    :class="`toolbar-layout ${seperator === 'line' ? 'line' : 'space'}`"
    :style="`margin-bottom:${marginBottom}`"
  >
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  props: {
    justify: {
      default: "end"
    },
    align: {
      default: "middle"
    },
    seperator: {
      default: "space"
    },
    marginBottom: {
      default: "0px"
    }
  }
};
</script>

<style lang="scss">
.toolbar-layout {
  &.space > *:not(:last-child) {
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
  &.space > *:not(:first-child) {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  &.line > *:not(:last-child) {
    border-right: 1px solid #5b6271;
    padding-right: 5px;
    margin-right: 5px;
  }
}
</style>
